export default __webpack_public_path__ + "static/media/1035.f3fe080c.png";